import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markChatAsUnread } from "@/api/chats";
import { ChatsQueryKeys } from "@/tanstackQuery/queries/chats";

export const useMarkChatAsUnread = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (chatId: number) => markChatAsUnread(chatId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ChatsQueryKeys.Chats] });
      queryClient.invalidateQueries({
        queryKey: [ChatsQueryKeys.ChatsPaginated],
      });
    },
  });
};
